import React from 'react';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import Spinner from 'react-spinkit';
import { Row, Col, Badge } from 'react-bootstrap';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import _ from 'underscore';
import { localStorageCoursesMethods } from '../../utils/utils';
// import uniq from 'lodash/uniq';

import StudentSteps from '../common/StudentSteps';
import * as runActions from '../../actions/runsActionCreators';
import * as courseActions from '../../actions/coursesActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as commonActions from '../../actions/commonActions';
import DropClassesTarget from './DropClassesTarget';
import ManageRulesPage from './ManageRulesPage';
import label from '../../utils/lngEn';
import ConfirmDeleteModal from '../common/ConfirmDeleteModal';
import LinksModal from './LinksModal';
import config from '../../config';
import InfoModal from '../../components/common/InfoModal';
import { setCoursesToAdd } from '../../actions/general'
import { getRequiredCreditsToProceed, getCurrentSelectionWeight, hasUnsavedChanges } from '../common/utils'


const onCloseWin = e => {
  e = e || window.event;

  // For IE and Firefox prior to version 4
  if (e) {
    e.returnValue =
      'You have not saved your class rankings. Your rankings are only saved once you view your potential schedules.';
  }

  // For Safari
  return 'You have not saved your class rankings. Your rankings are only saved once you view your potential schedules.';
};

_.mixin({
  mergeById: function mergeById(arr, obj, idProp) {
      var index = _.findIndex(arr, function (elem) {
          // double check, since undefined === undefined
          return typeof elem[idProp] !== 'undefined' && elem[idProp] === obj[idProp];
      });

      if (index > -1) {
          arr[index] = obj;
      } else {
          arr.push(obj);
      }

      return arr;
  }
});

class RankClassesPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      coursesLoaded: false,
      courses: [],
      goodCourses: [],
      favoriteCourses: [],
      greatCourses: [],
      dropSource: '',
      dragIndex: '',
      hoverIndex: '',
      preferencesLoaded: false,
      showLinksModal: false,
      showDeleteModal: false,
      confirmDeleteLimitPreferenceTitle: '',
      confirmDeleteLimitPreferenceMsg: '',
      deleteLimitPreferenceId: '',
      linksModalValues: {
        title: '',
        initialValues: {
          is_time_conflict: false
        }
      },
      isInSameBucket: true,
      showInfoModal: false,
      ranked: false,
      limit_preferences: {}
    };

    this.moveClass = this.moveClass.bind(this);
    this.addCoursesFromPreferences = this.addCoursesFromPreferences.bind(this);

    this.handleTargetDrop = this.handleTargetDrop.bind(this);
    this.handleApply = this.handleApply.bind(this);

    // Links modal
    this.openLinksModal = this.openLinksModal.bind(this);
    this.closeLinksModal = this.closeLinksModal.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.editLimitPreferenceModal = this.editLimitPreferenceModal.bind(this);
    this.openDeleteModel = this.openDeleteModel.bind(this);
    this.handleDeleteLimitPreference = this.handleDeleteLimitPreference.bind(this);
    this.updateLimitPreferenceTable = this.updateLimitPreferenceTable.bind(this);

    this.getCourseLocations = this.getCourseLocations.bind(this);

    // Remove item from drop target bucket
    this.removeItem = this.removeItem.bind(this);

    this.isWeightGood = this.isWeightGood.bind(this);

    // Info modal when remove the item
    this.closeInfoModal = this.closeInfoModal.bind(this);
  }

  getCourseLocations(id) {
    let course = this.props.courses.find(course => {
      return course.id == id;
    });
    return commonActions.getCourseLocations(course);
  }

  componentDidMount() {
    window.onbeforeunload = this.handleCloseWindow();

    // ** if we are loading fresh we don't have run data, so get it
    if (!this.props.run.id) this.props.runActions.getRun();

    // ** if we are loading fresh, we don't have a student, so get that too
    if (!this.props.student.id) {
      this.props.studentActions.getStudent().then(res => {
        if (res.target_course_units < 1) {
          browserHistory.push('/rank/' + localStorage.getItem('run') + '/start');
        }
      });
    }

    this.props.studentActions.getLinks().then(res => {
      this.setState({ limit_preferences: res.results });
    });

    // ** 2021 - just get the data on load for now
    if (!this.props.coursesToAdd.length) {
      this.props.courseActions.getAllCourses().then(() => {
        this.props.runActions.getAllRankPreferences().then(() => {
          const currentCourses = this.props.student.preferences.map(p => this.props.courses.find(c => c.id === p.course))
          this.props.setCoursesToAdd(currentCourses)
          this.addCoursesFromPreferences(this.props.student.preferences, this.props.coursesToAdd);
        });
      });
    } else {
      this.addCoursesFromPreferences(this.props.student.preferences, this.props.coursesToAdd);
    }

    // hook if we move around with rank set!
    this.props.router.setRouteLeaveHook(this.props.route, (nextLocation) => {
      if (this.state.ranked && nextLocation) {
        // get the last part of splitting nextLocation.path
        const p = nextLocation.pathname.split('/').slice(-1)[0];
        if (['start', 'find'].includes(p)) {
          return `You have unsaved information, are you sure you want to leave this page? (${nextLocation})`
        }
      }
    })
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', onCloseWin);
  }

  addCoursesFromPreferences(preferences, coursesToAdd) {

    
    // coursesToAdd is the source of truth.
    const allCoursesToAdd = coursesToAdd.reduce((acc, curr) => {
      // first, put ones that match rankings into right category
      const foundIt = preferences.find(p => p.course === curr.id)
      if (foundIt)  {
        // Add both the course and its score for sorting later
        const courseWithScore = { ...curr, score: foundIt.score };
        switch(foundIt.preference_class) {
          case 0:
            acc.favorite.push(courseWithScore)
            break
          case 1:
            acc.great.push(courseWithScore)
            break
          case 2:
            acc.good.push(courseWithScore)
            break
          case 3:
          default:
            acc.acceptable.push(courseWithScore)
            break
        }
      } else {
        // all the others go in acceptable with a score of 0
        acc.acceptable.push({ ...curr, score: 0 })
      }

      // return the list
      return acc
    }, {
      acceptable: [],
      good: [],
      great: [],
      favorite: []
    })

    // Sort each category by score in descending order (higher score = higher rank)
    // Then remove the score property as it's no longer needed
    const sortAndClean = (courses) => courses
      .sort((a, b) => b.score - a.score)
      .map(({ score, ...course }) => course);

    let state = {
      ...this.state,
      courses: sortAndClean(allCoursesToAdd.acceptable),
      goodCourses: sortAndClean(allCoursesToAdd.good),
      greatCourses: sortAndClean(allCoursesToAdd.great),
      favoriteCourses: sortAndClean(allCoursesToAdd.favorite),
      coursesLoaded: true,
      preferencesLoaded: true
    };
    this.setState(state);
  }

  // Set state to move the class row
  moveClass(dragIdnex, hoverIndex, target, isInSameBucket) {
    this.setState({ dropSource: target, dragIndex: dragIdnex, hoverIndex: hoverIndex, isInSameBucket });
  }

  handleTargetDrop(item, target) {
    const { course } = item;

    let acceptableCourses = this.state.courses.slice();
    let goodCourses = this.state.goodCourses.slice();
    let greatCourses = this.state.greatCourses.slice();
    let favoriteCourses = this.state.favoriteCourses.slice();
    const hoverIndex = new Number(this.state.hoverIndex);

    if (hoverIndex != -1) {
      // Remove item from current array
      acceptableCourses.map((c, i) => {
        if (c.id == course.id) {
          acceptableCourses.splice(i, 1);
          this.setState({ courses: acceptableCourses });
        }
      });

      goodCourses.map((c, i) => {
        if (c.id == course.id) {
          goodCourses.splice(i, 1);
          this.setState({ goodCourses });
        }
      });

      greatCourses.map((c, i) => {
        if (c.id == course.id) {
          greatCourses.splice(i, 1);
          this.setState({ greatCourses });
        }
      });
      favoriteCourses.map((c, i) => {
        if (c.id == course.id) {
          favoriteCourses.splice(i, 1);
          this.setState({ favoriteCourses });
        }
      });

      // Check if drag item is in the same bucket as drop target item
      if (this.state.isInSameBucket) {
        // Put in target array
        if (target == config.dndTypes.ACCEPTABLE) {
          // acceptableCourses.push(course);
          acceptableCourses.splice(hoverIndex, 0, course);
          // let a = acceptableCourses;
          this.setState({ courses: acceptableCourses });
        } else if (target == config.dndTypes.GOOD) {
          goodCourses.splice(hoverIndex, 0, course);
          this.setState({ goodCourses: goodCourses });
        } else if (target == config.dndTypes.GREAT) {
          greatCourses.splice(hoverIndex, 0, course);
          this.setState({ greatCourses: greatCourses });
        } else if (target == config.dndTypes.FAVORITE) {
          if (favoriteCourses.length > 0) {
            let c = favoriteCourses[0];
            favoriteCourses.splice(0, 1);
            favoriteCourses.splice(hoverIndex, 0, course);
            greatCourses.splice(0, 0, c);
            this.setState({ favoriteCourses: favoriteCourses });
            this.setState({ greatCourses: greatCourses });
            localStorageCoursesMethods.addCourseRankingPosition(c.id, config.dndTypes.GREAT);
          } else {
            favoriteCourses.splice(hoverIndex, 0, course);
            this.setState({ favoriteCourses: favoriteCourses });
          }
        }
      } else {
        // Put in target array
        if (target == config.dndTypes.ACCEPTABLE) {
          acceptableCourses.push(course);
          // acceptableCourses.splice(hoverIndex, 0, course);
          // let a = acceptableCourses;
          this.setState({ courses: acceptableCourses });
        } else if (target == config.dndTypes.GOOD) {
          goodCourses.push(course);
          // goodCourses.splice(hoverIndex, 0, course);
          this.setState({ goodCourses: goodCourses });
        } else if (target == config.dndTypes.GREAT) {
          greatCourses.push(course);
          // greatCourses.splice(hoverIndex, 0, course);
          this.setState({ greatCourses: greatCourses });
        } else if (target == config.dndTypes.FAVORITE) {
          if (favoriteCourses.length > 0) {
            let c = favoriteCourses[0];
            favoriteCourses.splice(0, 1);
            favoriteCourses.splice(hoverIndex, 0, course);
            greatCourses.splice(0, 0, c);
            this.setState({ favoriteCourses: favoriteCourses });
            this.setState({ greatCourses: greatCourses });

            localStorageCoursesMethods.addCourseRankingPosition(c.id, config.dndTypes.GREAT);
          } else {
            favoriteCourses.splice(hoverIndex, 0, course);
            this.setState({ favoriteCourses: favoriteCourses });
          }
        }
      }
    }

    localStorageCoursesMethods.addCourseRankingPosition(course.id, target);

    this.setState({ ranked: true });
    this.handleCloseWindow();
  }

  // Apply rankings
  handleApply() {
    window.removeEventListener('beforeunload', onCloseWin);
    let preferences = [];

    let c0 = this.state.favoriteCourses.slice(); // Favorite class
    let c1 = this.state.greatCourses.slice(); // Great classes
    let c2 = this.state.goodCourses.slice(); // Good classes
    let c3 = this.state.courses.slice(); // Acceptable classes

    c0.map((item, i) => {
      let score = Math.round(100 * (c0.length - i) / (c0.length + 1));
      let obj = {
        course: item.id,
        score,
        preference_class: 0
      };
      preferences.push(obj);
    });
    c1.map((item, i) => {
      let score = Math.round(100 * (c1.length - i) / (c1.length + 1));
      let obj = {
        course: item.id,
        score,
        preference_class: 1
      };
      preferences.push(obj);
    });
    c2.map((item, i) => {
      let score = Math.round(100 * (c2.length - i) / (c2.length + 1));
      let obj = {
        course: item.id,
        score,
        preference_class: 2
      };
      preferences.push(obj);
    });
    c3.map((item, i) => {
      let score = Math.round(100 * (c3.length - i) / (c3.length + 1));
      let obj = {
        course: item.id,
        score,
        preference_class: 3
      };
      preferences.push(obj);
    });
    this.props.runActions.postRankPreferences(preferences);
  }

  openDeleteModel(id, name) {
    this.setState({
      showDeleteModal: true
    });
    this.setState({ deleteLimitPreferenceId: id });
    this.setState({ confirmDeleteLimitPreferenceTitle: name });
    this.setState({
      confirmDeleteLimitPreferenceMsg: 'Are you sure you want to delete this Rule?'
    });
  }

  updateLimitPreferenceTable(obj) {
    let res = _.mergeById(this.state.limit_preferences, obj, 'id');
    this.setState({limit_preferences: res});
  }

  handleDeleteLimitPreference() {
    let c = this.state.deleteLimitPreferenceId;
    if (c != '') {
      this.props.studentActions.deleteLinks(this.state.deleteLimitPreferenceId);
      let res = _.reject(this.state.limit_preferences,
        function (d) { return d.id == c; });
      this.setState({
        limit_preferences: res
      });
    }
    this.setState({ showDeleteModal: false });
  }

  // Links
  openLinksModal() {
    let coursesArray = [];
    this.state.courses.map(course => {
      coursesArray.push(course);
    });
    this.state.goodCourses.map(course => {
      coursesArray.push(course);
    });
    this.state.greatCourses.map(course => {
      coursesArray.push(course);
    });
    this.state.favoriteCourses.map(course => {
      coursesArray.push(course);
    });

    let courses = [];
    if (this.props.student.links[0] && this.props.student.links[0].courses.length != 0) {
      this.props.student.links[0].courses.map(courseId => {
        let c = commonActions.getCourseObjById(courseId, this.props.courses);
        courses.push(c);
      });
    }

    this.setState({
      showLinksModal: true,
      linksModalValues: {
        title: `${label.linksForm_title}`,
        id: this.props.student.id,
        coursesArray,
        initialValues: {
          limit: '1',
          courses,
          name: ''
        }
      }
    });
  }

  editLimitPreferenceModal(limitPreference={}) {
    let coursesArray = [];
    this.state.courses.map(course => {
      coursesArray.push(course);
    });
    this.state.goodCourses.map(course => {
      coursesArray.push(course);
    });
    this.state.greatCourses.map(course => {
      coursesArray.push(course);
    });
    this.state.favoriteCourses.map(course => {
      coursesArray.push(course);
    });
    
    // Sort courses by slug (course code) alphabetically
    coursesArray.sort((a, b) => {
      return a.slug.localeCompare(b.slug);
    });

    let {courses=[] , limit='1', name='', id=''} = limitPreference;
    let title = _.isEmpty(limitPreference) ? label.linksForm_title : label.linksForm_title_modify;

    this.setState({
      showLinksModal: true,
      linksModalValues: {
        title: `${title}`,
        id: this.props.student.id,
        coursesArray: coursesArray,
        initialValues: {
          limit: limit.toString(),
          courses,
          name: name,
          id: id
        }
      }
    });
  }

  closeLinksModal() {
    this.setState({ showLinksModal: false });
  }

  closeDeleteModal() {
    this.setState({ showDeleteModal: false });
  }

  // Remove course from list
  removeItem(target, c) {
    if (this.isWeightGood() - c.weight < 2 * this.props.student.max_course_units) {
      this.setState({ showInfoModal: true });
      return;
    }

    if (target == config.dndTypes.ACCEPTABLE) {
      let courses = this.state.courses.slice();
      courses.map((item, index) => {
        if (item.id == c.id) {
          courses.splice(index, 1);
        }
        this.setState({ courses });
      });
    } else if (target == config.dndTypes.GOOD) {
      let goodCourses = this.state.goodCourses.slice();
      goodCourses.map((item, index) => {
        if (item.id == c.id) {
          goodCourses.splice(index, 1);
        }
        this.setState({ goodCourses });
      });
    } else if (target == config.dndTypes.GREAT) {
      let greatCourses = this.state.greatCourses.slice();
      greatCourses.map((item, index) => {
        if (item.id == c.id) {
          greatCourses.splice(index, 1);
        }
        this.setState({ greatCourses });
      });
    } else if (target == config.dndTypes.FAVORITE) {
      let favoriteCourses = this.state.favoriteCourses.slice();
      favoriteCourses.map((item, index) => {
        if (item.id == c.id) {
          favoriteCourses.splice(index, 1);
        }
        this.setState({ favoriteCourses });
      });
    }

    this.props.setCoursesToAdd(this.props.coursesToAdd.filter(a => a.id !== c.id))
  }

  // Return weight sum of items
  isWeightGood() {
    let weightSum = 0;
    this.state.courses.map(c => {
      weightSum += c.weight;
    });
    this.state.goodCourses.map(c => {
      weightSum += c.weight;
    });
    this.state.greatCourses.map(c => {
      weightSum += c.weight;
    });
    this.state.favoriteCourses.map(c => {
      weightSum += c.weight;
    });

    return weightSum;
  }
  closeInfoModal() {
    this.setState({ showInfoModal: false });
  }

  shouldNotGoNext() {
    return getCurrentSelectionWeight(this.props.coursesToAdd) >= getRequiredCreditsToProceed(this.props.student.max_course_units)
  }

  handleCloseWindow() {
    if (this.state.ranked) {
      window.addEventListener('beforeunload', onCloseWin);
    }
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <StudentSteps active={2} />
          </Col>
        </Row>
        {this.state.coursesLoaded && this.state.preferencesLoaded ? (
          <div>
            <Row>
              <Col md={7}>
                <div className="page-subtitle mt-0" style={{ marginBottom: '0px' }}>Rank your selections</div>
              </Col>
              <Col md={5}>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  className="btn btn-width-auto btn-primary"
                  disabled={!this.shouldNotGoNext()}
                  onClick={() => {
                    this.handleApply();
                  }}
                >
                  Submit Rankings
                </button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', textAlign: 'center'}}>
                  <strong>You must submit your rankings for them to be saved</strong>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={7} className="mb-4">
                {hasUnsavedChanges(this.props.student.preferences, this.props.coursesToAdd)
                  ? <Badge style={{ padding: '6px', backgroundColor: 'red' }}>Rankings not yet saved</Badge>
                  : null
                }
              </Col>
            </Row>
            
            <Row className="mb-4">
              <Col md={9}>
                {this.props.run.additional_rank_classes != null ? (
                  <p className="lead" dangerouslySetInnerHTML={{
                    __html: this.props.run.additional_rank_classes
                      .replace('[[[primary_contact_email]]]',
                        `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`)
                  }}>
                  </p>
                ) : (
                    ''
                  )}
              </Col>
            </Row>
            {this.props.run.show_favorite_rank
            ? (
                <Row>
                  <Col md={12}>
                    {/* <p className="description-text">{label.rankText1}</p>
                <p className="description-text">
                  {label.rankText2} <i className="fa fa-gg-circle color-gray font-size-20" /> {label.rankText3}
                </p> */}
                    <div className="drop-target-title">
                      <h3>Favorite</h3>
                    </div>
                    <DropClassesTarget
                      accepts={config.dndTypes.CLASS}
                      onDrop={item => this.handleTargetDrop(item, config.dndTypes.FAVORITE)}
                      courses={this.state.favoriteCourses}
                      getCourseLocations={this.getCourseLocations}
                      moveClass={this.moveClass}
                      target={config.dndTypes.FAVORITE}
                      linkedCourses={this.props.student.links[0] ? this.props.student.links[0].courses : null}
                      openLinksModal={this.openLinksModal}
                      removeItem={this.removeItem}
                    />
                  </Col>
                </Row>
            )
            : null
          }

            <Row>
              <Col md={12}>
                <div className="drop-target-title">
                  <h3>Great</h3>
                </div>
                <DropClassesTarget
                  accepts={config.dndTypes.CLASS}
                  onDrop={item => this.handleTargetDrop(item, config.dndTypes.GREAT)}
                  courses={this.state.greatCourses}
                  getCourseLocations={this.getCourseLocations}
                  moveClass={this.moveClass}
                  target={config.dndTypes.GREAT}
                  linkedCourses={this.props.student.links[0] ? this.props.student.links[0].courses : null}
                  openLinksModal={this.openLinksModal}
                  removeItem={this.removeItem}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="drop-target-title">
                  <h3>Good</h3>
                </div>
                <DropClassesTarget
                  accepts={config.dndTypes.CLASS}
                  onDrop={item => this.handleTargetDrop(item, config.dndTypes.GOOD)}
                  courses={this.state.goodCourses}
                  getCourseLocations={this.getCourseLocations}
                  moveClass={this.moveClass}
                  target={config.dndTypes.GOOD}
                  linkedCourses={this.props.student.links[0] ? this.props.student.links[0].courses : null}
                  openLinksModal={this.openLinksModal}
                  removeItem={this.removeItem}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="drop-target-title">
                  <h3>Acceptable</h3>
                </div>
                <DropClassesTarget
                  accepts={config.dndTypes.CLASS}
                  onDrop={item => this.handleTargetDrop(item, config.dndTypes.ACCEPTABLE)}
                  courses={this.state.courses}
                  getCourseLocations={this.getCourseLocations}
                  moveClass={this.moveClass}
                  target={config.dndTypes.ACCEPTABLE}
                  linkedCourses={this.props.student.links[0] ? this.props.student.links[0].courses : null}
                  openLinksModal={this.openLinksModal}
                  removeItem={this.removeItem}
                />
              </Col>
            </Row>
            <Row>
              {this.props.run.show_rules && (
                <ManageRulesPage
                  openLinksModal={this.openLinksModal}
                  courses={this.props.courses}
                  limit_preferences={this.state.limit_preferences}
                  editLimitPreferenceModal={this.editLimitPreferenceModal}
                  openDeleteModel={this.openDeleteModel}
                  courses={this.props.courses}
                />
              )}
            </Row>
          </div>
        ) : (
          <div className="spinner-box">
            <Spinner spinnerName="three-bounce" className="mt-4" />
          </div>
        )}

        <LinksModal
          closeModal={this.closeLinksModal}
          showModal={this.state.showLinksModal}
          onCancel={this.closeLinksModal}
          initial={this.state.linksModalValues}
          updateLimitPreferenceTable={this.updateLimitPreferenceTable}
        />
        <ConfirmDeleteModal
          closeModal={this.closeDeleteModal}
          showModal={this.state.showDeleteModal}
          onCancel={this.closeDeleteModal}
          customTitle={this.state.confirmDeleteLimitPreferenceTitle}
          customMsg={this.state.confirmDeleteLimitPreferenceMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteLimitPreference}
        />
        <InfoModal
          closeModal={this.closeInfoModal}
          showModal={this.state.showInfoModal}
          onCancel={this.closeInfoModal}
          customTitle="Cannot Remove Class"
          customMsg="Removing this class would leave you with too few selections. Please go back and change your selections instead."
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses,
    coursesToAdd: state.general.coursesToAdd
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    courseActions: bindActionCreators(courseActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    setCoursesToAdd: bindActionCreators(setCoursesToAdd, dispatch)
  };
}

RankClassesPage = DragDropContext(HTML5Backend)(RankClassesPage);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RankClassesPage));



// WEBPACK FOOTER //
// ./src/components/rank/RankClassesPage.js